import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import Icon from '../../../ui/Icon'
import { HeroCourt } from '../../../ui/courtSvg/CourtSvg'

type HomeHeroCourtProps = {
  minOneEntryPrice?: number
  minOneEntrySlotDuration?: number
  isOpen?: boolean
}

export const HomeHeroCourt = ({
  minOneEntryPrice,
  minOneEntrySlotDuration,
  isOpen = false,
}: HomeHeroCourtProps) => {
  const { t } = useTranslation('home')

  return (
    <div className="hero-court">
      <div className="ph-row ph-between hero-court-header">
        <span className="eyebrow hero-court-eyebrow">
          {t('hero.visual.liveFallback')}
        </span>
        <span className={isOpen ? 'badge badge-accent' : 'badge'}>
          {t(isOpen ? 'hero.visual.badge.open' : 'hero.visual.badge.closed')}
        </span>
      </div>
      <div className="hero-court-graphic">
        <HeroCourt />
      </div>
      <div className="ph-row ph-between hero-court-footer">
        <div className="hero-court-cta">
          <div className="mono hero-court-label">
            {t('hero.visual.nextSlot')}
          </div>
          <Link to="/guest-booking" className="hero-court-slots-link">
            <span className="display hero-court-value">
              {t('hero.visual.checkSlots')}
            </span>
            <Icon name="arrowR" size={14} />
          </Link>
        </div>
        <div className="hero-court-meta-end">
          <div className="mono hero-court-label">{t('hero.visual.from')}</div>
          <div className="display hero-court-value">
            {minOneEntryPrice != null
              ? t('hero.visual.price', { price: minOneEntryPrice })
              : '\u2014'}{' '}
            <span className="hero-court-duration">
              {minOneEntrySlotDuration != null
                ? t('hero.visual.duration', {
                    minutes: minOneEntrySlotDuration,
                  })
                : null}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
